define('Header.Menu.View.Extension', [
  'Header.Menu.View',
  'Profile.Model',

  'Backbone',
  'jQuery',
  'Utils',
  'underscore'
], function (
  HeaderMenuView,
  ProfileModel,

  Backbone,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(HeaderMenuView.prototype, {
    getContext: _.wrap(HeaderMenuView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var prof = ProfileModel.getInstance();
      var loggedIn = prof.get('isLoggedIn') === 'T';

      if (loggedIn) {
        context.categories = _.filter(context.categories, function (cat) {
          return cat.href !== '/register';
        });
      } else {
        context.categories = _.filter(context.categories, function (cat) {
          return cat['data-type'] !== 'commercecategory';
        });
      }

      return context;
    })
  });
});
